<template>
  <modal
    width="600px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
  >
    <p slot="header">考前承诺</p>
    <div slot="content">
      <p class="content" v-html="content"></p>
    </div>

    <div slot="footer">
      <button class="white-btn" @click="onNotAgree">不同意</button>
      <button
        :style="'box-shadow: '+ $store.state.theme.buttonShadow+'background: '+ $store.state.theme.buttonBackground"
        class="blue-btn"
        @click="onAgree">{{ bottonContent }}</button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { getExamId } from '@/utils';
import { get } from '@/utils/ajax'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: true,
      content: '',
      bottonContent: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      let { exam_config } = this.$store.state.examConfig

      // 为了兼容从其他系统直接跳转过来拿不到数据的情况
      if (!exam_config) {
        const examId = getExamId()
        try {
          const data = await get(`/home/exams/check/${examId}`) // 配置信息
          exam_config = data.exam_config
        } catch (e) {
          this.$router.push({ name: 'list' })
          return
        }
      }
      this.content = (exam_config.find(item => item.label === 'LARGE_EXAM#exam_commitment_content') || {}).actual_value
      this.bottonContent = (exam_config.find(item => item.label === 'LARGE_EXAM#exam_commitment_button_content') || {}).actual_value
    },
    onAgree() {
      const examId = getExamId()
      localStorage.setItem(`exam_commitment_${examId}`, true)
      this.$emit('goTest')
      this.close()
    },
    onNotAgree() {
      this.close()
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .content {
    height: 350px;
    overflow: auto;
    background: #fafafa;
    padding: 20px;
  }
  .white-btn {
    @include cancel-btn(96px, 36px, 14px, 4px);
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .blue-btn {
    @include theme-fill-btn-no-width(96px, 36px, 14px, 4px);
  }
  .text {
    font-size: 16px;
    margin: 10px 0;
  }
</style>
